import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
    /**
     * Transforma um texto, truncando-o para um tamanho máximo e adicionando '...' no final.
     *
     * @param value O texto a ser truncado.
     * @param limit O número máximo de caracteres (padrão: 20).
     * @param trail O sufixo a ser adicionado após o texto truncado (padrão: '...').
     * @returns O texto truncado.
     */
    transform(
        value: string,
        limit: number = 20,
        trail: string = '...',
    ): string {
        // Se o valor de entrada não for uma string ou estiver vazio, retorna uma string vazia.
        if (!value) {
            return '';
        }

        // Se o texto for menor ou igual ao limite, retorna o texto original sem alterações.
        if (value.length <= limit) {
            return value;
        }

        // Trunca o texto para o limite especificado e adiciona o sufixo.
        return value.substring(0, limit) + trail;
    }
}
